<template>
  <div>
    <div class="table-listings">
      <el-table ref="multipleTable" :data="smsLogs" style="width: 100%" class="mt-4">
				<!-- Date -->
        <el-table-column label="Date" min-width="60" prop="date" sortable>
          <template slot-scope="scope">
            <p class="top-line">{{ scope.row.created_at | dateFormatString }}</p>
          </template>
        </el-table-column>

        <!-- Message -->
        <el-table-column label="Message" min-width="270" prop="sms_content">
          <template slot-scope="scope">
            <p class="top-line">{{ scope.row.sms_content }}</p>
          </template>
        </el-table-column>

        <!-- Sent By -->
        <!-- <el-table-column label="Sent By" min-width="130" prop="created_by" sortable>
          <template slot-scope="scope">
            <p class="top-line">{{ _gHlp.getValue(scope.row,'created_by_detail.name') }}</p>
          </template>
        </el-table-column> -->

        <el-table-column label="Sent">
          <template slot-scope="scope">
            <i class="fa fa-check-circle text-success fa-lg" v-if="scope.row.status == '1'"></i>
            <i class="fa fa-times text-red fa-lg" v-if="scope.row.status == '0'"></i>
          </template>
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script>

import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button } from 'element-ui'

export default {
  name: 'history-log-tab',
  props: [
    'sms-logs'
  ],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },
  data() {
    return {
      tableData: [
        {
          message: 'Reminder: Credit Loan is due RM1000.00',
          sent_by: 'Admin',
          date: '23 Nov 2022',
          isSent: 1,
        },
        {
          message: 'Reminder: Credit Loan is due RM4000.00',
          sent_by: 'Admin',
          date: '22 Nov 2022',
          isSent: 1,
        },
        {
          message: 'Reminder: Remember to make payment of RM15,000.00',
          sent_by: 'Zahid',
          date: '15 Nov 2022',
          isSent: 0,
        },
      ]
    }
  },

  methods: {
  },
}

</script>